import { isNetworkError, isTransientAuthError, TimeoutError } from '@platform/api';

/**
 * True when a failed session probe leaves the session itself intact, so a cached
 * identity stays trustworthy. Deliberately separate from retryPolicy: same error
 * taxonomy, different question, and a timeout is where they diverge (the session
 * survives one, retrying it is still pointless).
 */
export function sessionSurvivesError(error: unknown): boolean {
  return error == null || isTransientAuthError(error) || isNetworkError(error) || error instanceof TimeoutError;
}
